/** Case-insensitive substring. An empty needle matches everything. */
export function includesFold(text: string | undefined, needle: string): boolean {
  if (needle === '') return true;
  return (text ?? '').toLowerCase().includes(needle);
}
